/**
 * The one slot the page's own list of lines is typed in: each "What you'll learn" line carries it, so the host
 * types over one line at a time, and an emptied line is taken out of the list. The page writer is told to mark
 * its lines with this name (`GENERATE_SYSTEM`, workers/src/ai/skills/pages.ts); the `page/text` route and the
 * walk's page step read it from here.
 */
export const LEARN_SLOT = "learn";
